export const DAFTAR_BACK_BASE_URL = process.env.VUE_APP_BASE_URL;
export const DAFTAR_FRONT_BASE_URL = process.env.VUE_APP_FRONT_URL
export const DAFTAR_AUTH_BASE_URL = process.env.VUE_APP_AUTH_URL